var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isBtnVisible)?_c('b-button',{attrs:{"size":"is-small","type":"is-primary","icon-left":"refresh","loading":_vm.syncingDevice},on:{"click":function($event){return _vm.syncDeviceConfig()}}},[_vm._v("Synchroniser")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }